import { HttpResponse1532ob1hsse1y as HttpResponse } from './HttpResponse.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  Companion_getInstance25751un9ltd4f as Companion_getInstance,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpResponseClass;
function DefaultHttpResponse() {
  if (DefaultHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, responseData) {
        super();
        this.o5v_1 = call;
        this.p5v_1 = responseData.s5j_1;
        this.q5v_1 = responseData.n5j_1;
        this.r5v_1 = responseData.q5j_1;
        this.s5v_1 = responseData.o5j_1;
        this.t5v_1 = responseData.t5j_1;
        var tmp = this;
        var tmp_0 = responseData.r5j_1;
        var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel()) ? tmp_0 : null;
        tmp.u5v_1 = tmp0_elvis_lhs == null ? Companion_getInstance().f4l_1 : tmp0_elvis_lhs;
        this.v5v_1 = responseData.p5j_1;
      }
      y5i() {
        return this.o5v_1;
      }
      cw() {
        return this.p5v_1;
      }
      h5j() {
        return this.q5v_1;
      }
      i5j() {
        return this.r5v_1;
      }
      j5j() {
        return this.s5v_1;
      }
      k5j() {
        return this.t5v_1;
      }
      g5j() {
        return this.u5v_1;
      }
      y51() {
        return this.v5v_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpResponse');
    DefaultHttpResponseClass = $;
  }
  return DefaultHttpResponseClass;
}
//region block: exports
export {
  DefaultHttpResponse as DefaultHttpResponse2wnrinzo0twhn,
};
//endregion

//# sourceMappingURL=DefaultHttpResponse.mjs.map
